import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { urlparams } from "../../config/bootstrap";
import { onClickNavLinkMantra } from "../../utils/helper";

const PmviewCard = ({ data }) => {
  let activity = data.activity ? data.activity : null;
  let name = data.name;
  const [TickArr, setTettickArr] = useState([]);
  useEffect(() => {
    if (localStorage.getItem("doneMantraArray")) {
      let doneMantraArray = JSON.parse(localStorage.getItem("doneMantraArray"));
      setTettickArr(doneMantraArray);
    }
  }, []);

  return (
    <div className="col-12">
      <section className="m5_card_wrp">
        <div className="row">
          {data &&
            data.image.length > 0 &&
            data.image.map((value, index) => {
              return (
                <div className="col-4" key={index}>
                  <img src={value} className="gp_img" />
                  <h5 className="m5_home_name">{name[index]}</h5>
                </div>
              );
            })}

          {/* <div className="col-4">
                    <img src="/assets/img/mantra5_2.png" className="gp_img" />
                </div>
                <div className="col-4">
                    <img src="/assets/img/mantra5_3.png" className="gp_img" />
                </div> */}
        </div>
        {
          activity &&
          Object.keys(activity).length > 0 &&
          Object.keys(activity).map((key, index) => {
            return (
              <div className="m5_card_txt_wrp mt10" key={key}>
                <NavLink
                  to={"/module/" + key + "/" + urlparams + "&view="}
                  onClick={() =>
                    onClickNavLinkMantra("/module/" + key, activity[key])
                  }
                >
                  <div className="ico_wrp_m5" id={"navigate_" + key} onClick={() => { localStorage.setItem('navigate', key) }}>
                    <img src={activity[key].icon} />
                  </div>
                </NavLink>
                <div className="mtext_wrp">
                  <h6 className="m1_text">
                    {activity[key].name}
                    {TickArr.includes(key) && <img src="/assets/img/tick.png" className="tick_img" />}
                  </h6>
                  <h3 className="m2_text">{activity[key].title}</h3>
                  {/* <h4 className="m3_text">
                    1488{" "}
                    <img src="/assets/img/svg/user.svg" className="user_ico" />
                  </h4> */}
                </div>
              </div>
            );
          })
        }
      </section>
    </div>
  );
};
export default PmviewCard;
